import Task from './Task';
import { ActivityValueSnapshot } from './TaskActivity';
import { User } from './User';
import Workspace from './Workspace';

export enum NotificationType {
  assigned_task = 'assigned_task',
  deleted_task = 'deleted_task',
  comment = 'comment',
  mention = 'mention',
  deadline = 'deadline',
  invited_to_space = 'invited_to_space',
  user_added_to_space = 'user_added_to_space',
  // Task-activity types (#625). Which property changed lives in
  // metadata.field rather than in a type per field.
  task_property_changed = 'task_property_changed',
  description_updated = 'description_updated',
  attachment_added = 'attachment_added',
  link_added = 'link_added',
  comment_reaction = 'comment_reaction',
  description_mention = 'description_mention',
}

/**
 * Property names as the notification cards say them (#625 Figma catalogue).
 * Close to but deliberately not the activity log's FIELD_LABELS: the cards read
 * "Task Type" and "Stage" where the activity log reads "Type" and "Sprint
 * Status". Mirrors server/src/services/notifications/notificationFormatter.ts.
 */
export const NOTIFICATION_FIELD_LABELS: Record<string, string> = {
  type: 'Task Type',
  stage: 'Stage',
  statusId: 'Status',
  priority: 'Priority',
  assignee: 'Owner',
  storyPoints: 'Estimate',
  estimate: 'Estimate',
  startDate: 'Start Date',
  deadline: 'Target Date',
  epicId: 'Epic',
  parentTaskId: 'Parent',
  blockingTaskId: 'Blocking',
  blockedTaskId: 'Blocked by',
};

/** Renderer payload for cards that show more than a sentence (#625). */
export type NotificationMetadata = {
  /** task_property_changed: which property, and the snapshots for the pills. */
  field?: string | null;
  oldValue?: ActivityValueSnapshot | null;
  newValue?: ActivityValueSnapshot | null;
  /** comment_reaction. */
  commentId?: number;
  emoji?: string;
};

export type Notification = {
  id: number;
  organizationId: number;
  type: NotificationType;
  read: boolean;
  requiresAction: boolean;
  done: boolean;
  archivedAt: string | null;
  message: string | null;
  metadata: NotificationMetadata | null;
  taskId: number | null;
  createdAt: Date;
  updatedAt: Date;
  User: User;
  Task: Task | null;
  Workspace: Workspace | null;
  Creator: User | null;
};

export type NotificationTab = 'actions' | 'updates';
export type NotificationFilter = 'read' | 'unread' | 'done' | 'notdone' | 'all';
export type NotificationsEnvelope = {
  items: Notification[];
  nextCursor: number | null;
  counts: { actions: number; updates: number };
};
